import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleDatePipe } from '../shared/shared-pipes/locale-date.pipe';
import { QuestionnaireRiskPipe } from '../shared/shared-pipes/questionnaire-risk.pipe';
import { SharedModule } from '../shared/shared.module';
import { DashboardNumberCardComponent } from './dashboard-number-card/dashboard-number-card.component';
import { DashboardComponent } from './dashboard.component';
import { ExpandedCardModal } from './widgets-view/dashboard-widget-card/expanded-card/expanded-card.modal';
import { WidgetTableCardComponent } from './widgets-view/dashboard-widget-card/widget-table-card/widget-table-card.component';
import { WidgetsViewComponent } from './widgets-view/widgets-view.component';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardNumberCardComponent,
    WidgetsViewComponent,
    QuestionnaireRiskPipe,
    WidgetTableCardComponent,
    ExpandedCardModal
  ],
  imports: [CommonModule, SharedModule],
  exports: [DashboardComponent],
  entryComponents: [ExpandedCardModal],
  providers: [LocaleDatePipe]
})
export class DashboardModule {}
